import NextLink, { type LinkProps as NextLinkProps } from "next/link";
import { type ReactNode } from "react";

export interface LinkProps extends NextLinkProps {
  children: ReactNode;
  className?: string;
  type?: string;
  title?: string;
}

export function Link({
  children,
  className,
  type,
  title,
  ...linkProps
}: LinkProps) {
  return (
    <NextLink {...linkProps} passHref legacyBehavior>
      <a className={className} type={type} title={title}>
        {children}
      </a>
    </NextLink>
  );
}
